import { Box, useTheme } from '@mui/material';
import { useState } from 'react';
import { selectNeedsStatus } from 'redux/slices/needs.slice';
import { useAppSelector } from 'redux/store-hooks';
import { FilterChips, FlexContainer } from '@act/storybook';
import { SYVA_NEEDS_FILTERS, SyvaNeedsFilter } from './syva-needs-filters';
import NeedsInfoCard from './syva-needs-info-card';
import NeedsList from './syva-needs-list';

import Loader from 'react-components/workflows/loader';
import { generateDatadogTrackingProps } from 'toolkit/environment/environment/user-monitoring';

const SyvaNeeds = () => {
  const theme = useTheme();

  const [syvaNeedsFilters, setSyvaNeedsFilters] = useState<SyvaNeedsFilter[]>(
    []
  );
  const status = useAppSelector(selectNeedsStatus);

  return (
    <FlexContainer
      direction="column"
      height="100%"
      padding="16px 12px 0"
      backgroundColor={theme.palette.surfaces.neutralLighter}
      gap={2}
      sx={{ position: 'relative' }}
    >
      <Box sx={{ flexShrink: 0 }}>
        <FilterChips
          filterChoices={SYVA_NEEDS_FILTERS}
          setSelectedFilters={setSyvaNeedsFilters}
          {...generateDatadogTrackingProps('needs-list-filter-chips')}
        />
      </Box>
      <FlexContainer direction="column" height="100%" gap={2}>
        {status === 'loading' && <Loader />}
        {status !== 'loading' && (
          <Box
            className="needs-container__inner"
            sx={{
              height: '100%',
              overflowY: 'auto',
              position: 'relative',
            }}
          >
            <NeedsInfoCard />
            <Box
              className="inner__scroller"
              sx={{
                height: 'fit-content',
              }}
            >
              <NeedsList filters={syvaNeedsFilters} />
            </Box>
          </Box>
        )}
      </FlexContainer>
    </FlexContainer>
  );
};

export default SyvaNeeds;
